"use client";
'use strict';

var React = require('react');
require('@sravni/ab-testing-sdk/lib/browser');
var Context = require('../providers/AbTestingProvider/Context.js');

function useAbTestingSdk() {
    return React.useContext(Context.AbTestingContext);
}

exports.useAbTestingSdk = useAbTestingSdk;
//# sourceMappingURL=useAbTestingSdk.js.map
